export default {
	SaveAccountSetting: "SaveAccountSetting",
	SendContactMessage: "SendContactMessage",
	SaveCommunicationSettings: "SaveCommunicationSettings",
	SaveNotificationsSettings: "SaveNotificationsSettings",
	ReconfirmPolicies: "ReconfirmPolicies",
};
